<div class="table__container">
	<div class="table__header">
		<h2 class="table__title">
			{{ title }}
		</h2>
	</div>
	<div class="table__wrapper">
		<table>
			<thead>
				<tr>
					<th>{{ 'attestation-summary-thematique' | translate }}</th>
					<th>{{ 'table_head-document-name' | translate }}</th>
					<th>{{ 'table_head-document-state' | translate }}</th>
					<th>{{ 'table_head-document-actions' | translate }}</th>
				</tr>
			</thead>
			<tbody *ngIf="displayRows && displayRows.length > 0; else noDocTpl">
				<tr *ngFor="let row of displayRows; trackBy: trackByThematique">
					<td class="thematique small">
						{{ getThematiqueName(row) }}
					</td>
					<td class="label small">
						<a
							*ngIf="row.hasDocument"
							(click)="handleView(row)"
							class="document-link"
							[title]="'common_view' | translate"
						>
							{{ getDocumentLabel(row) }}
						</a>
						<span *ngIf="!row.hasDocument">-</span>
					</td>
					<td class="state small">
						<ng-container *ngIf="row.hasDocument">
							<span
								class="badge"
								[ngClass]="{
									'badge-created':
										getDocumentStatus(row) === 'created',
									'badge-generated':
										getDocumentStatus(row) === 'generated',
									'badge-signed':
										getDocumentStatus(row) === 'signed'
								}"
							>
								{{
									'document_state-' + getDocumentStatus(row)
										| translate
								}}
							</span>
						</ng-container>
						<span *ngIf="!row.hasDocument">-</span>
					</td>
					<td>
						<div class="actions">
							<!-- Generate button -->
							<button
								nz-button
								nzType="default"
								class="icon-btn"
								[title]="'common_generate' | translate"
								[disabled]="loading"
								(click)="handleGenerate(row)"
							>
								<i
									nz-icon
									nzType="file-add"
									nzTheme="outline"
								></i>
							</button>

							<!-- Download button -->
							<button
								nz-button
								nzType="default"
								class="icon-btn"
								[title]="'common_download' | translate"
								[disabled]="!row.hasDocument"
								(click)="row.hasDocument && handleDownload(row)"
							>
								<i
									nz-icon
									nzType="download"
									nzTheme="outline"
								></i>
							</button>

							<!-- Delete button -->
							<button
								nz-button
								nzType="default"
								class="icon-btn delete"
								[title]="'common_delete' | translate"
								[disabled]="!row.hasDocument"
								(click)="row.hasDocument && handleDelete(row)"
							>
								<i
									nz-icon
									nzType="delete"
									nzTheme="outline"
								></i>
							</button>

							<!-- Edit stagiaires button -->
							<button
								nz-button
								nzType="default"
								class="icon-btn"
								[title]="'common_edit' | translate"
								(click)="openEditModal(row)"
							>
								<i nz-icon nzType="edit" nzTheme="outline"></i>
							</button>
						</div>
					</td>
				</tr>
			</tbody>
			<ng-template #noDocTpl>
				<tbody>
					<tr>
						<td colspan="4" class="no-doc">
							<ng-container *ngIf="loading; else noDataTpl">
								<i nz-icon nzType="loading" class="mr-2"></i>
								{{ 'common_loading' | translate }}
							</ng-container>
							<ng-template #noDataTpl>
								{{ 'table_no_documents' | translate }}
							</ng-template>
						</td>
					</tr>
				</tbody>
			</ng-template>
		</table>
	</div>
</div>

<!-- Edit Stagiaires Modal -->
<nz-modal
	[(nzVisible)]="editModalVisible"
	[nzTitle]="
		'presence-signature_modal-management-title'
			| translate : { name: editModalThematique?.props?.name }
	"
	(nzOnCancel)="closeEditModal()"
	[nzFooter]="null"
	nzWidth="900px"
>
	<!-- Loading -->
	<div *ngIf="editModalLoading" class="text-center p-4">
		<i nz-icon nzType="loading"></i> {{ 'common_loading' | translate }}
	</div>

	<!-- Stagiaire Groups -->
	<div *ngIf="!editModalLoading" class="stagiaire-modal-content">
		<div
			*ngFor="let group of stagiaireGroups; trackBy: trackByGroup"
			class="group-section"
		>
			<!-- Collapsible Header -->
			<div
				class="group-header"
				(click)="toggleGroup(group)"
				[class.expanded]="isGroupExpanded(group)"
			>
				<i
					nz-icon
					[nzType]="
						isGroupExpanded(group) ? 'minus-circle' : 'plus-circle'
					"
					nzTheme="outline"
					class="expand-icon"
				></i>
				<h4 class="group-title">
					{{ group.date | date : 'dd MMMM yyyy' : '' : 'fr-FR' }}
					- {{ getPeriodLabel(group.period) }}
				</h4>
				<span
					class="stagiaire-count"
					[class.has-missing]="getMissingSignaturesCount(group) > 0"
				>
					<ng-container *ngIf="getMissingSignaturesCount(group) > 0">
						{{
							'presence-signature_count-missing'
								| translate
									: {
											count: getMissingSignaturesCount(
												group
											)
									  }
						}}
					</ng-container>
					<ng-container
						*ngIf="getMissingSignaturesCount(group) === 0"
					>
						{{ 'presence-signature_count-complete' | translate }}
					</ng-container>
				</span>
			</div>

			<!-- Stagiaires Table -->
			<div *ngIf="isGroupExpanded(group)" class="stagiaires-container">
				<table class="stagiaires-table">
					<thead>
						<tr>
							<th>
								{{
									'presence-signature_table-name' | translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-state' | translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-signed-at'
										| translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-absence'
										| translate
								}}
							</th>
							<th>
								{{
									'presence-signature_table-actions'
										| translate
								}}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							*ngFor="
								let stagiaire of group.stagiaires;
								trackBy: trackByStagiaire
							"
						>
							<td class="stagiaire-name">
								{{ stagiaire.stagiaire_name }}
							</td>
							<td class="stagiaire-status">
								<span
									*ngIf="stagiaire.signed"
									class="d-flex align-items-center justify-content-center"
								>
									<i
										nz-icon
										nzType="check-circle"
										nzTheme="fill"
										class="mr-2"
										style="color: #52c41a"
									></i>
									<span>
										{{
											'presence-signature_status-already-signed'
												| translate
										}}
									</span>
								</span>
								<span
									*ngIf="!stagiaire.signed"
									class="d-flex align-items-center justify-content-center"
								>
									<i
										nz-icon
										nzType="close-circle"
										nzTheme="outline"
										class="mr-2"
										style="color: #999"
									></i>
									<span>
										{{
											'presence-signature_status-not-signed'
												| translate
										}}
									</span>
								</span>
							</td>
							<td class="signed-at">
								<span *ngIf="stagiaire.signed_at">
									{{
										stagiaire.signed_at
											| date
												: 'dd/MM/yyyy HH:mm'
												: ''
												: 'fr-FR'
									}}
								</span>
								<span *ngIf="!stagiaire.signed_at">-</span>
							</td>
							<td class="delay">
								<span
									*ngIf="
										stagiaire.delay && stagiaire.delay > 0
									"
									class="delay-badge"
								>
									{{ stagiaire.delay }} min
								</span>
								<span
									*ngIf="
										!stagiaire.delay ||
										stagiaire.delay === 0
									"
									>-</span
								>
							</td>
							<td class="action">
								<div class="action-buttons">
									<button
										nz-button
										[nzType]="
											stagiaire.signed
												? 'default'
												: 'primary'
										"
										nzSize="small"
										(click)="
											openDelayModal(stagiaire, group)
										"
									>
										{{
											(stagiaire.signed
												? 'presence-signature_action-edit-absence'
												: 'presence-signature_action-sign'
											) | translate
										}}
									</button>
									<button
										*ngIf="
											stagiaire.signed &&
											stagiaire.attestation_id
										"
										nz-button
										nzType="default"
										nzSize="small"
										nzDanger
										class="icon-only"
										(click)="openDeleteModal(stagiaire)"
									>
										<i
											nz-icon
											nzType="delete"
											nzTheme="outline"
										></i>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Empty state -->
		<div *ngIf="stagiaireGroups.length === 0" class="empty-state">
			{{ 'presence-signature_empty-presence-sessions' | translate }}
		</div>
	</div>
</nz-modal>

<!-- Delay Management Modal -->
<nz-modal
	[(nzVisible)]="delayModalVisible"
	[nzTitle]="delayModalTitle"
	(nzOnCancel)="closeDelayModal()"
	(nzOnOk)="submitDelayModal()"
	[nzOkText]="'presence-signature_modal-ok' | translate"
	[nzCancelText]="'presence-signature_modal-cancel' | translate"
	[nzOkLoading]="delayModalLoading"
>
	<div class="form-group">
		<label>
			{{ 'presence-signature_modal-absence-label' | translate }}
		</label>
		<input
			nz-input
			type="number"
			[(ngModel)]="delayValue"
			min="0"
			placeholder="0"
		/>
	</div>
</nz-modal>

<!-- Delete Confirmation Modal -->
<nz-modal
	[(nzVisible)]="deleteModalVisible"
	[nzTitle]="'presence-signature_modal-delete-title' | translate"
	(nzOnCancel)="closeDeleteModal()"
	(nzOnOk)="confirmDeleteAttestation()"
	[nzOkText]="'presence-signature_modal-delete-ok' | translate"
	[nzCancelText]="'presence-signature_modal-cancel' | translate"
	[nzOkLoading]="deleteModalLoading"
	nzOkDanger
>
	<p
		[innerHTML]="
			'presence-signature_modal-delete-confirm'
				| translate
					: {
							name:
								'<strong>' +
								(selectedAttestationForDelete?.stagiaireName ||
									'') +
								'</strong>'
					  }
		"
	></p>
</nz-modal>
